export default "__VITE_ASSET__DRNBROwc__"